module.exports = __webpack_public_path__ + "static/media/tooltip.c221230f.svg";